<template>
  <div>
    <t-modal
      :header="'Copywriting assistant'"
      xs
      @close="() => (showAiTextDialog = false)"
    >
      <template #dialog-body>
        <div class="content-container">
          <div class="w-full" style="padding: 0 20px">
            <!-- <t-text-area
              v-model="aiTextPrompt"
              :rows="6"
              class="w-full"
              data-testid="invisible-preheader"
            ></t-text-area> -->

            <div
              role="textbox"
              class="rounded-lg bg-gray-800 p-4 text-white"
              contenteditable="true"
              @change="onChange"
              v-html="aiTextPrompt"
            ></div>

            <div
              class="mb-10 mt-4 grid w-full auto-cols-max grid-flow-col gap-2"
            >
              <t-button class="px-2 py-1" :disabled="loading" @click="improve">
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.90625 2.88672C8.93359 2.80469 9.01562 2.75 9.125 2.75C9.20703 2.75 9.28906 2.80469 9.31641 2.88672L9.69922 3.92578L10.7383 4.30859C10.8203 4.33594 10.875 4.41797 10.875 4.5C10.875 4.60938 10.8203 4.69141 10.7383 4.71875L9.69922 5.10156L9.31641 6.11328C9.28906 6.19531 9.20703 6.25 9.125 6.25C9.01562 6.25 8.93359 6.19531 8.90625 6.11328L8.52344 5.10156L7.48438 4.71875C7.40234 4.69141 7.375 4.60938 7.375 4.5C7.375 4.41797 7.40234 4.33594 7.48438 4.30859L8.52344 3.92578L8.90625 2.88672ZM15.6602 3.16016L16.5898 4.08984C17.1094 4.60938 17.1094 5.42969 16.5898 5.94922L6.17188 16.3672C5.65234 16.8867 4.83203 16.8867 4.3125 16.3672L3.38281 15.4375C2.86328 14.918 2.86328 14.0977 3.38281 13.5781L13.8008 3.16016C14.3203 2.64062 15.1406 2.64062 15.6602 3.16016ZM14.7305 4.0625L11.7227 7.07031L12.6797 8.02734L15.6602 5.01953L14.7305 4.0625ZM5.24219 15.4375L11.75 8.95703L10.793 8L4.3125 14.5078L5.24219 15.4375ZM2.31641 5.97656L3.875 5.375L4.44922 3.84375C4.47656 3.70703 4.61328 3.625 4.75 3.625C4.85938 3.625 4.99609 3.70703 5.02344 3.84375L5.625 5.375L7.15625 5.97656C7.29297 6.00391 7.375 6.14062 7.375 6.25C7.375 6.38672 7.29297 6.52344 7.15625 6.55078L5.625 7.125L5.02344 8.68359C4.99609 8.79297 4.85938 8.875 4.75 8.875C4.61328 8.875 4.47656 8.79297 4.44922 8.68359L3.875 7.125L2.31641 6.55078C2.17969 6.52344 2.125 6.38672 2.125 6.25C2.125 6.14062 2.17969 6.00391 2.31641 5.97656ZM11.9414 12.9766L13.5 12.375L14.0742 10.8438C14.1016 10.707 14.2383 10.625 14.375 10.625C14.4844 10.625 14.6211 10.707 14.6484 10.8438L15.25 12.375L16.7812 12.9766C16.918 13.0039 17 13.1406 17 13.25C17 13.3867 16.918 13.5234 16.7812 13.5508L15.25 14.125L14.6484 15.6836C14.6211 15.793 14.4844 15.875 14.375 15.875C14.2383 15.875 14.1016 15.793 14.0742 15.6836L13.5 14.125L11.9414 13.5508C11.8047 13.5234 11.75 13.3867 11.75 13.25C11.75 13.1406 11.8047 13.0039 11.9414 12.9766Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>{{ t("editor.improve") }}</span>
              </t-button>
              <t-button class="px-2 py-1" :disabled="loading" @click="rephrase">
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.8125 6.25H11.7227V7.78125C11.7227 8.05469 11.8594 8.30078 12.1055 8.41016C12.3516 8.49219 12.6523 8.4375 12.8438 8.24609L15.0312 6.05859C15.2773 5.8125 15.2773 5.40234 15.0312 5.15625L12.8438 2.96875C12.6523 2.77734 12.3516 2.72266 12.1055 2.80469C11.8594 2.91406 11.7227 3.16016 11.7227 3.40625V4.9375H7.8125C5.13281 4.9375 3 7.09766 3 9.75C3 10.1328 3.27344 10.4062 3.65625 10.4062C4.01172 10.4062 4.3125 10.1328 4.3125 9.75C4.3125 7.83594 5.87109 6.25 7.8125 6.25ZM16.3438 9.09375C15.9609 9.09375 15.6875 9.39453 15.6875 9.75C15.6875 11.6914 14.1016 13.25 12.1875 13.25H8.25V11.7188C8.25 11.4727 8.08594 11.2266 7.83984 11.1172C7.59375 11.0352 7.29297 11.0898 7.12891 11.2539L4.91406 13.4414C4.66797 13.7148 4.66797 14.125 4.91406 14.3711L7.12891 16.5586C7.29297 16.75 7.59375 16.8047 7.83984 16.7227C8.08594 16.6133 8.25 16.3672 8.25 16.0938V14.5625H12.1875C14.8398 14.5625 17 12.4297 17 9.75C17 9.39453 16.6992 9.09375 16.3438 9.09375Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>{{ t("editor.rephrase") }}</span>
              </t-button>
              <t-button
                class="px-2 py-1"
                :disabled="loading"
                @click="makeLonger"
              >
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17 9.75C17 9.94141 16.918 10.1328 16.7812 10.2422L13.9375 12.8672C13.8008 12.9766 13.6367 13.0312 13.5 13.0312C13.3086 13.0312 13.1445 12.9766 13.0078 12.8398C12.7617 12.5664 12.7617 12.1562 13.0352 11.9102L14.6484 10.4062H5.32422L6.9375 11.9102C7.21094 12.1562 7.21094 12.5664 6.96484 12.8398C6.82812 12.9766 6.66406 13.0312 6.5 13.0312C6.33594 13.0312 6.17188 12.9766 6.03516 12.8672L3.19141 10.2422C3.05469 10.1328 3 9.94141 3 9.75C3 9.58594 3.05469 9.39453 3.19141 9.28516L6.03516 6.66016C6.30859 6.41406 6.71875 6.41406 6.96484 6.6875C7.21094 6.96094 7.21094 7.37109 6.9375 7.61719L5.32422 9.09375H14.6484L13.0352 7.61719C12.7891 7.37109 12.7617 6.96094 13.0078 6.6875C13.2539 6.41406 13.6641 6.41406 13.9375 6.66016L16.7812 9.28516C16.918 9.39453 17 9.58594 17 9.75Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>{{ t("editor.make_longer") }}</span>
              </t-button>
              <t-button
                class="hover:my-class px-2 py-1"
                :disabled="loading"
                @click="makeShorter"
              >
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.9062 14.8633L11.5312 11.1992L12.543 10.3242L16.7539 13.8516C17.0273 14.0977 17.0547 14.5078 16.8359 14.7812C16.5898 15.0547 16.1797 15.082 15.9062 14.8633ZM6.0625 2.75C7.73047 2.75 9.125 4.14453 9.125 5.8125C9.125 6.30469 8.98828 6.76953 8.79688 7.17969L10.8477 8.90234L15.9062 4.66406C16.1797 4.44531 16.5898 4.47266 16.8359 4.74609C17.0547 5.01953 17.0273 5.42969 16.7539 5.67578L8.79688 12.3477C8.98828 12.7578 9.125 13.2227 9.125 13.6875C9.125 15.3828 7.73047 16.75 6.0625 16.75C4.36719 16.75 3 15.3828 3 13.6875C3 12.0195 4.36719 10.625 6.0625 10.625C6.77344 10.625 7.45703 10.8984 7.97656 11.3086L9.83594 9.75L7.97656 8.21875C7.45703 8.62891 6.77344 8.875 6.0625 8.875C4.36719 8.875 3 7.50781 3 5.8125C3 4.14453 4.36719 2.75 6.0625 2.75ZM4.3125 5.8125C4.3125 6.79688 5.07812 7.5625 6.0625 7.5625C7.01953 7.5625 7.8125 6.79688 7.8125 5.8125C7.8125 4.85547 7.01953 4.0625 6.0625 4.0625C5.07812 4.0625 4.3125 4.85547 4.3125 5.8125ZM6.0625 11.9375C5.07812 11.9375 4.3125 12.7305 4.3125 13.6875C4.3125 14.6719 5.07812 15.4375 6.0625 15.4375C7.01953 15.4375 7.8125 14.6719 7.8125 13.6875C7.8125 12.7305 7.01953 11.9375 6.0625 11.9375Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>{{ t("editor.make_shorter") }}</span>
              </t-button>
              <t-button
                class="px-2 py-1"
                :disabled="loading"
                @click="summarize"
              >
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6875 14.125C8.6875 13.4141 8.08594 12.8125 7.375 12.8125H4.75C4.50391 12.8125 4.3125 12.6211 4.3125 12.375V4.5C4.3125 4.28125 4.50391 4.0625 4.75 4.0625H15.25C15.4688 4.0625 15.6875 4.28125 15.6875 4.5V12.375C15.6875 12.6211 15.4688 12.8125 15.25 12.8125H11.4492C11.1484 12.8125 10.875 12.9219 10.6562 13.0859L8.6875 14.5625V14.125ZM8.66016 16.2305L8.6875 16.2031L11.4492 14.125H15.25C16.207 14.125 17 13.3594 17 12.375V4.5C17 3.54297 16.207 2.75 15.25 2.75H4.75C3.76562 2.75 3 3.54297 3 4.5V12.375C3 13.3594 3.76562 14.125 4.75 14.125H6.0625H7.375V15.4375V15.5469V15.5742V15.7383V16.3125C7.375 16.5039 7.45703 16.6406 7.59375 16.7227C7.75781 16.7773 7.92188 16.7773 8.05859 16.668L8.52344 16.3125L8.66016 16.2305ZM7.375 5.8125C6.88281 5.8125 6.5 6.22266 6.5 6.6875V8C6.5 8.49219 6.88281 8.875 7.375 8.875H8.25V9.09375C8.25 9.39453 8.00391 9.66797 7.67578 9.72266L7.48438 9.77734C7.10156 9.83203 6.88281 10.1602 6.9375 10.5156C6.99219 10.8711 7.32031 11.1172 7.67578 11.0625L7.89453 11.0352C8.85156 10.8711 9.5625 10.0508 9.5625 9.09375V8V7.34375V6.6875C9.5625 6.22266 9.15234 5.8125 8.6875 5.8125H7.375ZM13.5 8V7.34375V6.6875C13.5 6.22266 13.0898 5.8125 12.625 5.8125H11.3125C10.8203 5.8125 10.4375 6.22266 10.4375 6.6875V8C10.4375 8.49219 10.8203 8.875 11.3125 8.875H12.1875V9.09375C12.1875 9.39453 11.9414 9.66797 11.6133 9.72266L11.4219 9.77734C11.0391 9.83203 10.8203 10.1602 10.875 10.5156C10.9297 10.8711 11.2578 11.1172 11.6133 11.0625L11.832 11.0352C12.7891 10.8711 13.5 10.0508 13.5 9.09375V8Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>Summarize</span>
              </t-button>
              <t-button
                class="px-2 py-1"
                :disabled="loading"
                @click="checkGrammar"
              >
                <template #icon>
                  <div class="flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.7148 6.16016C16.9727 6.41797 16.9727 6.83203 16.7148 7.08984L8.96484 14.8398C8.70703 15.0977 8.29297 15.0977 8.03516 14.8398L4.28516 11.0898C4.02734 10.832 4.02734 10.418 4.28516 10.1602C4.54297 9.90234 4.95703 9.90234 5.21484 10.1602L8.5 13.4453L15.7852 6.16016C16.043 5.90234 16.457 5.90234 16.7148 6.16016Z"
                        fill="#CBCBCD"
                      />
                    </svg>
                  </div>
                </template>
                <span>{{ t("editor.check_grammar") }}</span>
              </t-button>
            </div>

            <div v-if="context" class="mb-8">
              <div
                v-for="(contextMessage, key) in context.messages"
                :key="key"
                class="mt-6"
              >
                <div
                  role="textbox"
                  class="rounded-lg bg-gray-800 p-4 text-white"
                  contenteditable="true"
                  @change="
                    (event: any) => {
                      contextMessage.answer = (event as any).target.innerHtml;
                    }
                  "
                  v-html="contextMessage.answer"
                ></div>

                <div class="mt-2 flex justify-between">
                  <div class="grid auto-cols-max grid-flow-col gap-2">
                    <t-button
                      :loading="loading"
                      @click="useInTemplate(contextMessage.answer)"
                    >
                      <span>Use in template</span>
                    </t-button>

                    <t-button
                      :loading="loading"
                      @click="useAsNewInput(contextMessage.answer)"
                    >
                      <span>Use as new input</span>
                    </t-button>
                  </div>

                  <div class="grid auto-cols-max grid-flow-col gap-2">
                    <t-button @click="copy(contextMessage.answer)">
                      <span v-if="!copied">Copy</span>
                      <span v-if="copied">Copied</span>
                    </t-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </t-modal>
  </div>
</template>

<script lang="ts" setup>
  import { useDialogsStore } from "@/stores/dialogs";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useAiTextStore } from "@/stores/aiTextStore";
  import { getText } from "@/composables/text-generator/useOpenAiApi";
  import IContext from "../../../types/Ai/Text/IContext";

  import { TButton, TModal } from "@topol/twig-ui";
  import { useClipboard } from "@vueuse/core";
  import { useI18n } from "vue-i18n";
  import { computed, onMounted, ref } from "vue";

  const { t } = useI18n();

  const dialogsStore = useDialogsStore();
  const mjmlStore = useMjmlStore();
  const aiTextStore = useAiTextStore();
  const loading = ref(false);

  const aiTextPrompt = ref(aiTextStore.promptText || "");
  const context = ref<IContext | undefined>(undefined);

  const { copy, copied } = useClipboard();

  const showAiTextDialog = computed({
    get() {
      return dialogsStore.addAiTextDialog.opened;
    },
    set() {
      dialogsStore.closeAiTextDialog();
    },
  });

  const makeShorter = () => {
    generateAiText('Make this text shorter: "' + aiTextPrompt.value + '"');
  };

  const makeLonger = () => {
    generateAiText(
      'Make this text little bit longer: "' + aiTextPrompt.value + '"'
    );
  };

  const rephrase = () => {
    generateAiText('Slightly Rephrase this text: "' + aiTextPrompt.value + '"');
  };

  const summarize = () => {
    generateAiText('Summarize this text: "' + aiTextPrompt.value + '"');
  };

  const improve = () => {
    generateAiText('Improve this text: "' + aiTextPrompt.value + '"');
  };

  const checkGrammar = () => {
    generateAiText(
      'Fix the spelling, grammar and punctuation mistakes in this text, including comma placement. Keep the original meaning, tone, structure and formatting unchanged. Do not rephrase or rewrite. Output just the resulting text: "' +
        aiTextPrompt.value +
        '"'
    );
  };

  const useInTemplate = (message: string) => {
    if (aiTextStore.blockId) {
      mjmlStore.updateSpecificBlockProp({
        prop: "content",
        value: message,
        sectionIndex: aiTextStore.sectionIndex,
        columnIndex: aiTextStore.columnIndex,
        blockIndex: aiTextStore.blockIndex,
      });
    } else {
      mjmlStore.addBlock({
        sectionIndex: aiTextStore.sectionIndex,
        columnIndex: aiTextStore.columnIndex,
        blockIndex: aiTextStore.blockIndex,
        type: "text",
        customBlockData: null,
        defaultContent: message,
      });
    }

    dialogsStore.closeAiTextDialog();
  };

  const onChange = (event: Event) => {
    //@ts-expect-error
    aiTextPrompt.value = event.target.innerHtml;
  };
  const useAsNewInput = (message: string) => {
    aiTextPrompt.value = message;
    aiTextStore.clearContext();
    getContext();
  };

  const generateAiText = async (prompt: string) => {
    loading.value = true;

    const text = await getText(
      prompt,
      mjmlStore.authorize.apiKey,
      mjmlStore.authorize.hostname,
      mjmlStore.authorize.userId
    );

    if (text === null) {
      loading.value = false;
      return;
    }

    const aiText = aiTextStore.cleanString(text);

    if (aiTextStore.blockId !== null) {
      aiTextStore.addMessageToBlockContext(aiTextStore.blockId, prompt, aiText);
    } else {
      aiTextStore.addMessageToNewBlockContext(prompt, aiText);
    }

    getContext();

    loading.value = false;
  };

  const getContext = () => {
    context.value = aiTextStore.getContextByBlockId(aiTextStore.blockId);
  };

  onMounted(function () {
    aiTextStore.clearContext();
    getContext();
  });
</script>

<style scoped lang="scss">
  .button-group-container {
    display: flex;
    justify-content: center;
    padding-bottom: 24px;
  }

  .content-container {
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
    min-width: 396px;
  }
</style>

<style>
  .t-t-modal .dialog {
    max-width: 650px !important;
    min-height: 0px !important;
  }

  .t-button__icon {
    padding-right: 5px;
  }

  .t-button {
    height: auto !important;
  }
</style>
